import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  Button,
  FormControlLabel,
  IconButton,
  Switch,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
const StandardDeduction = ({ classes }) => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "minStoneWeightPercentage", label: "Min Stone Weight Percentage" },
    { id: "maxStoneWeightPercentage", label: "Max Stone Weight Percentage" },
    { id: "standardDeduction", label: "Standard Deduction" },
    // { id: "action", label: "action" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteRoleId, setDeleteRoleId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [isActive, setIsActive] = useState(true);
  // submit create function
  const handlecreateroleSubmit = () => {
    navigate(`/coreservice/role-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DEDUCTION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        result.data = result?.data?.sort((a, b) =>
        a.minStoneWeightPercentage > b.minStoneWeightPercentage ? 1 : -1
      );
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };
  // const handleStatusChange = async (id, index, checked) => {
  //   setCallInProgress(true);
  //   const result = await apiHandler({
  //     url: endpoint.DEDUCTION_STATUS_UPDATE + id + "?status=" + checked,
  //     method: "PATCH",
  //     authToken: authToken,
  //   });
  //   setCallInProgress(false);
  //   if (result?.data?.error_code) {
  //   } else {
  //     GetData();
  //   }
  // };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((role, index) => {
        if (role.status === "INACTIVE") {
          setIsActive(false);
        }
        if (role.status === "ACTIVE") {
          setIsActive(true);
        }
        let row = {
          minStoneWeightPercentage: role.minStoneWeightPercentage,
          maxStoneWeightPercentage: role.maxStoneWeightPercentage,
          standardDeduction: role.standardDeduction,
          // action: getIcons(role.id, index, role.status),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  // const getIcons = (role, index, status) => {
  //   return status === "ACTIVE" ? (
  //     <input
  //       id="selectAll"
  //       type="checkbox"
  //       checked={isActive}
  //       className={classes.checkboxInput}
  //       onChange={(e) => {
  //         handleStatusChange(role, index, "INACTIVE");
  //       }}
  //     />
  //   ) : (
  //     <input
  //       id="selectAll"
  //       type="checkbox"
  //       checked={!isActive}
  //       className={classes.checkboxInput}
  //       onChange={(e) => {
  //         handleStatusChange(role, index, "ACTIVE");
  //       }}
  //     />
  //   );
  // };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteRoleId("");
  };
  const handlePositiveResponse = async () => {
    const roleid = deleteRoleId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Role
    const res = await apiHandler({
      url: endpoint.MASTER_ROLE_DELETE + roleid + "?role=" + roleid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Standard Deduction deleted successful", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      const standardDeduction = row.standardDeduction.toString().toLowerCase();
    const minStoneWeightPercentage = row.minStoneWeightPercentage.toString().toLowerCase();
    const maxStoneWeightPercentage = row.maxStoneWeightPercentage.toString().toLowerCase();

    return (
      standardDeduction.includes(val) ||
      minStoneWeightPercentage.includes(val) ||
      maxStoneWeightPercentage.includes(val)
    );
  });
    parseIndicatorData(filteredData);
  };
  const handleCreateStandardDeduction = () => {
    navigate(`/coreservice/StandardDeduction-create`);
  };
  const buttonLabel = rawData?.length ? "Edit Deduction" : "Create";
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label=" Standard Deduction"
          button1={buttonLabel}
          button1click={handleCreateStandardDeduction}
          onSearchChange={onSearchChange}
          searchLabel = "Search For Standard Deduction"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default StandardDeduction;
